import PrintProductConfiguratorHeaderPane from './PrintProductConfiguratorHeaderPane';

export default PrintProductConfiguratorHeaderPane;
